import { render, staticRenderFns } from "./TrendsDropdownModule.vue?vue&type=template&id=43014f6c&scoped=true&"
import script from "./TrendsDropdownModule.vue?vue&type=script&lang=js&"
export * from "./TrendsDropdownModule.vue?vue&type=script&lang=js&"
import style0 from "./TrendsDropdownModule.vue?vue&type=style&index=0&id=43014f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43014f6c",
  null
  
)

export default component.exports